import styled from 'styled-components';

export const AnimationContainer = styled.div<{ animation?: string }>`
  transition: all 0.5s ease;
  position: absolute;
  width: 100%;

  ${({ animation }) => {
    if (animation === 'fadeInUp') {
      return `
        transform: translate3d(0, 0, 0);
        opacity: 1;
      `;
    } else if (animation === '') {
      return `
        transform: translate3d(0, 30px, 0);
        opacity: 0;
      `;
    }
  }}
`;

export const AbsoluteContainer = styled.div`
  position: relative;
  width: 100%;
`;
